<!-- 图文导航 -->
<template>
    <div v-if="componentsData.type == 1"
        :style="`
            padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px; background:${componentsData.content.bg_color};
            border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;
        `"
    >
        <div :class="componentsData.content.iconList.length > 1 ? 'flex-sb' : 'flex-c'" class="overflow-hidden">
            <div class="ta-c" v-for="(item, index) of componentsData.content.iconList" :key="index">
                <img v-if="componentsData.content.type_id == 1 || componentsData.content.type_id == 3" :src="item.picview"
                    :style="`width: ${componentsData.content.width}px;height: ${componentsData.content.height}px;`"
                />
                <div class="fw-bold" :style="`color: ${componentsData.content.text_color};`"
                    v-if="componentsData.content.type_id == 1 || componentsData.content.type_id == 2"
                >
                    {{ item.title }}
                </div>
                <div class="txt" v-if="componentsData.content.type_id == 1 || componentsData.content.type_id == 2">
                    {{ item.describe }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.fw-bold {
    font-weight: bold;
}
.txt {
    font-size: 12px;
    color: #bebebe;
}
</style>